var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79302 11.4768L17.506 5.22199C16.1376 1.33407 20.9709 -1.77297 23.8677 1.15674C26.2913 3.60765 24.5654 7.81477 21.1405 7.81477C19.9723 7.81477 18.9162 7.28838 18.2043 6.4434L7.49136 12.6982C7.78793 13.5407 7.78793 14.4709 7.49136 15.3134L18.2043 21.5683C20.5243 18.8146 24.9973 20.4844 24.9973 24.0969C24.9973 27.5605 20.8371 29.3058 18.4135 26.8549C17.3703 25.8 17.0027 24.2198 17.5063 22.7894L6.79302 16.5345C4.47279 19.2881 0 17.6181 0 14.0058C0 10.3936 4.4731 8.72321 6.79302 11.4768ZM5.59352 12.2496C4.05009 10.6891 1.401 11.8004 1.401 14.0058C1.401 16.2116 4.0504 17.3223 5.59352 15.762C6.55244 14.792 6.55244 13.2193 5.59352 12.2496ZM22.8771 2.15851C21.3337 0.597985 18.6849 1.70926 18.6849 3.91471C18.6849 6.12047 21.3343 7.23113 22.8771 5.67092C23.8363 4.70089 23.836 3.12823 22.8771 2.15851ZM22.8771 22.3407C21.3337 20.7805 18.6849 21.8912 18.6849 24.0969C18.6849 26.3027 21.3343 27.4134 22.8771 25.8532C23.836 24.8831 23.836 23.3105 22.8771 22.3407Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.b275cabca54e3ab50eccee96bd8b3459.svg";
export { ForwardRef as ReactComponent };